import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { map } from 'rxjs';


import { fadeInUp400ms } from '@vex/animations/fade-in-up.animation';
import { stagger80ms } from '@vex/animations/stagger.animation';
import {
  NavigationLink,
  NavigationSubheading,
} from '../../../core/navigation/navigation-item.interface';

import { BaseComponent } from '@shared/components/base/base-component/base.component';
import { HomeCardComponent } from '@shared/components/home-card/home-card.component';

@Component({
    selector: 'app-comissoes',
    imports: [AsyncPipe, HomeCardComponent],
    templateUrl: './comissoes.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [fadeInUp400ms, stagger80ms]
})
export class ComissoesComponent extends BaseComponent implements OnInit {
  protected cards$ = this.navigationService.items$.pipe(
    map((items) => {
      const routerSplitted = this.router.url.split('/');
      const submenu = routerSplitted[routerSplitted.length - 1];
      if (!submenu) {
        return;
      }

      const comissoesItems = items.find(
        (item) => item.type === 'subheading' && item.id === submenu
      ) as NavigationSubheading;
      const comissoesLinks = comissoesItems.children.reduce<NavigationLink[]>(
        (prev, curr) => {
          if (curr.type === 'dropdown') {
            prev = [
              ...prev,
              ...(curr.children.filter(
                (item) => item.type === 'link'
              ) as NavigationLink[]),
            ];
          } else {
            prev.push(curr);
          }
          return prev;
        },
        []
      );
      return comissoesLinks || [];
    })
  );

  ngOnInit(): void {
    this.setBreadcrumbs([]);
  }
}
